
import React, { useEffect, useState } from "react";
import API from '../Services/Product';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import ViewBothProduct from "./ViewBothProduct";
import ComboProduct from "./ComboProduct";
import APISS from '../Services/Location';
import ProductType from "../Components/ProductType";

const ProductList = ({ type }) => {
    const perPage = 10;
    const [productList, setProductList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [search, setSearch] = useState("");

    const [fetchData, setFetchData] = useState("");
    const [fetchDetails, setFetchDetails] = useState("");
    const [location, setLocation] = useState([])
    const [location1, setLocation1] = useState([])
    const [selectedLocation, setSelectedLocation] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [productType, setProductType] = useState([])
    const productTypeFlag = 'All';
    useEffect(() => {
        let isCombo = type === "single" ? 0 : 1;
        getProductList(isCombo);
        bindLocation();
    }, [currentPage, type]);

    const bindLocation = async () => {
        try {
            const response = await APISS.getLocationList({
                is_active: 1,
                limit: 0,
            });
            setLocation(response?.data?.data || []);
            // setLocation1(response?.data?.data || [])
        } catch (error) {
            //setError("Failed to fetch locations.");
            console.error(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
        }
    };

    const getProductList = async (isCombo) => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage,
                search,
                is_combo: isCombo,
            };

            if (selectedLocation) {
                payload.location_id = selectedLocation;
            }

            if (selectedStatus) {
                payload.is_active = selectedStatus;
            }

            if (productType && productType.length > 0) {
                payload.product_type_id = productType;
            }
            // console.log("Filtered Payload:", payload);

            const response = await API.Get_Product(payload);
            setProductList(response?.data?.data || []);
            setTotalRecords(response?.data?.totalCount || 0);
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login");
                toast.error("Unauthorized access.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        const totalPages = Math.ceil(totalRecords / perPage);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
        }
    };
    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };

    const changeStatus = async (productId, currentStatus) => {
        const updatedStatus = !currentStatus;
        try {
            const response = await API.changeProductStatusData(productId, updatedStatus);
            if (response.status === 200) {
                setProductList((prev) =>
                    prev.map((item) =>
                        item.id === productId ? { ...item, is_active: updatedStatus } : item
                    )
                );
                toast.success(`Product ${updatedStatus ? "Active" : "De-Activated"} successfully!`);
            } else {
                toast.error("Failed to update the status.");
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            toast.error("Failed to update the status.");
        }
    };

    const handleGetData = async (productId, combo, type) => {

        try {
            const response = await API.Get_Product({ id: productId });
            const data = response?.data?.data?.[0];

            if (!data) return toast.error("Failed to fetch product details.");
            if (type === "view") {
                setFetchData(data);
            } else {
                setFetchDetails(data);
            }
        } catch (error) {
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            toast.error("An error occurred while fetching product details.");
        }
    };

    const handleFieldChange2 = (e, fieldName) => {
        const value = e.target.value;
        if (fieldName === "search") {
            setSearch(value);
            if (value.trim() === "") {
                setCurrentPage(1);
                getProductList(type === "single" ? 0 : 1);
            }
        }
    };

    const handleSearchData = () => {
        setCurrentPage(1);
        getProductList(type === "single" ? 0 : 1);
    };
    const handleGetProductDetails = (id, combo, type) => {
        handleGetData(id, combo, type);
    };

    const handleGetProductData = (id, combo, type) => {
        handleGetData(id, combo, type);
    };

    return (
        <div>
            <div className="col-lg-12 grid-margin stretch-card mt-5">
                <div className="card rounded-0">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added {type} Product</h4>
                    </div>

                    <div className="card-body">
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        Search By
                                    </label>
                                    <input type="text" className="form-control" placeholder="Search By Name"
                                        value={search}
                                        onChange={(e) => handleFieldChange2(e, "search")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        Center
                                    </label>
                                    <select
                                        className="form-select"
                                        id="ddSalesType"
                                        value={selectedLocation}
                                        onChange={(e) => setSelectedLocation(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {location.map((item) => (
                                            <option key={item.id} value={item.id}>
                                                {item.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>


                            <div className="col-md-3">
                                <div className="form-group">
                                    <ProductType
                                        selectedProductType={productType}
                                        setSelectedProductType={setProductType}
                                        type={productTypeFlag}
                                    />
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="ddSalesType" className="form-label">
                                        Status
                                    </label>
                                    <select
                                        className="form-select"
                                        id="ddSalesType"
                                        value={selectedStatus}
                                        onChange={(e) => setSelectedStatus(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <button onClick={handleSearchData} className="btn btn-success" type="button">Search</button>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr>
                                        <th>SrNo</th>
                                        <th>Action</th>
                                        <th>Name</th>
                                        <th>Center Name</th>
                                        <th>Sales Tab Name</th>
                                        <th>Product Type</th>
                                        <th>Display Order</th>
                                        {/* <th>SkyCoins</th> */}
                                        <th>
                                            {type === "single" ? "SkyCoins (Normal)" : type === "combo" ? "Price" : ""}
                                        </th>
                                        <th>SkyCoins (SPCL)</th>
                                        {/* <th>Description</th> */}
                                        <th>Is Recipe</th>
                                        <th>Track Inventory</th>

                                        {type === "single" && (
                                            <th>Expose Api</th>
                                        )}
                                        <th>Status</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {productList.map((item, index) => (
                                        <tr key={item.id} data-active={item?.is_active ? "true" : "false"}>
                                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                                            <td>
                                                <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                    <ul className="navbar-nav navbar-nav-right">
                                                        <li className="nav-item nav-profile1">
                                                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <div className="nav-profile-text1">
                                                                    <p className="mb-1 text-black">
                                                                    </p>
                                                                </div>
                                                            </span>
                                                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                                <a className="dropdown-item">
                                                                    <button
                                                                        onClick={() => handleGetProductDetails(item?.id, item?.is_combo, 'view')} // pass `isCombo`
                                                                        className="btn btn-success btn-sm"
                                                                        type="button"
                                                                    >
                                                                        View
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">
                                                                    <button onClick={() => handleGetProductData(item.id, item?.is_combo, 'edit')}
                                                                        className="btn btn-primary btn-sm" type="button"
                                                                    >
                                                                        Edit
                                                                    </button>
                                                                </a>
                                                                <div className="dropdown-divider"></div>
                                                                <a className="dropdown-item">

                                                                    <button
                                                                        className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                        onClick={() => changeStatus(item.id, item.is_active)}>
                                                                        {item.is_active ? "De-Activate" : "Activate"}
                                                                    </button>

                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.location_name}</td>
                                            <td>{item.sale_tab_name}</td>
                                            <td>{item.product_type_name}</td>
                                            {/* <td>{item.tax_rate_type}</td> */}
                                            <td>{item.display_order}</td>
                                            <td>{item.amount}</td>
                                            <td>{item?.special_price}</td>

                                            <td>{item.track_inventory ? "True" : "False"}</td>
                                            {type === "single" && (
                                                <td>{item.track_inventory ? "True" : "False"}</td>
                                            )}

                                            {type === "single" && (
                                             <td>{item.expose_api ? "True" : "False"}</td>
                                                // <td>{item?.["expose_api "] ? "True" : "False"}</td>

                                            )}
                                            <td>{item.is_active ? "Active" : "De-Activated"}</td>
                                            <td>
                                                {moment(item.createdAt).format("DD-MM-YYYY")}
                                            </td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                            {productList.length > 0 && (
                                <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-center mt-4">
                                        {/* Previous Button */}
                                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Previous
                                            </button>
                                        </li>

                                        {getPageNumbers().map((page, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                            >
                                                {page === "..." ? (
                                                    <span className="page-link">...</span>
                                                ) : (
                                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                                        {page}
                                                    </button>
                                                )}
                                            </li>
                                        ))}

                                        <li
                                            className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                            >
                                                Next
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}

                        </div>

                    </div>
                </div>
            </div>
            <ViewBothProduct fetchData={fetchData}
            />
            <ComboProduct fetchDetails={fetchDetails} />
        </div>
    );
};

export default ProductList;
